import {defineAsyncComponent} from 'vue';

const AuditReceiveInitialExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/auditInitial/auditReceiveInitial/AuditReceiveInitialExpenseFeesDetail.vue'),
);
const AuditReceiveInitialRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/auditInitial/auditReceiveInitial/AuditReceiveInitialRevenueBusinessDetail.vue'),
);
const AuditReceiveInitialExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/auditInitial/auditReceiveInitial/AuditReceiveInitialExpenseBusinessDetail.vue'),
);
const AuditReceiveInitialRegularDetail = defineAsyncComponent(() =>
  import('@/views/auditInitial/auditReceiveInitial/AuditReceiveInitialRegularDetail.vue'),
);
const AuditReceiveInitialProjectDetail = defineAsyncComponent(() =>
  import('@/views/auditInitial/auditReceiveInitial/AuditReceiveInitialProjectDetail.vue'),
);
export function auditReceiveInitialRegister(app) {
  app.component('AuditReceiveInitialExpenseFeesDetail', AuditReceiveInitialExpenseFeesDetail);
  app.component('AuditReceiveInitialRevenueBusinessDetail', AuditReceiveInitialRevenueBusinessDetail);
  app.component('AuditReceiveInitialExpenseBusinessDetail', AuditReceiveInitialExpenseBusinessDetail);
  app.component('AuditReceiveInitialRegularDetail', AuditReceiveInitialRegularDetail);
  app.component('AuditReceiveInitialProjectDetail', AuditReceiveInitialProjectDetail);
}
